module.exports = __webpack_public_path__ + "static/media/image (14).e70cfd90.jpg";